import { render, staticRenderFns } from "./ParcelGeo.vue?vue&type=template&id=d0397d64&"
import script from "./ParcelGeo.vue?vue&type=script&lang=js&"
export * from "./ParcelGeo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports